// @ts-nocheck
import LocalStorage, { LOCAL_STORAGE_KEYS } from '../../utils/LocalStorage';
import * as types from '../types';

const currentAppVersion = LocalStorage.getItem(LOCAL_STORAGE_KEYS.appVersion);

if (!currentAppVersion) {
    LocalStorage.setItem(LOCAL_STORAGE_KEYS.appVersion, '1');
}

const initialState = {
    appVersion: LocalStorage.getItem(LOCAL_STORAGE_KEYS.appVersion),
    isUpdatePasswordModalVisible: false,
    ticketInfoModalProps: {
        isVisible: false,
        ticket: {},
        isSettlementStatusChanged: false,
        unSavedTicket: {},
        ticketCancelModal: false,
    },
    currentPage: '',
    errorModalProps: {
        isVisible: false,
        error: {},
    },
    actionBlock: {
        isFetching: false,
        actions: [],
    },
    confirmModalProps: {
        isVisible: false,
        isConfirmed: false,
        placeholder: null,
    },
    translationMode: false,
    downloadFileList: [],
};

const global = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case types.APP_VERSION_CHANGED: {
            return {
                ...state,
                appVersion: payload,
            };
        }
        case types.UPDATE_PASSWORD_MODAL_VISIBILITY_CHANGED: {
            return {
                ...state,
                isUpdatePasswordModalVisible: payload,
            };
        }
        case types.TICKET_INFO_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                ticketInfoModalProps: {
                    ...state.ticketInfoModalProps,
                    ...payload,
                },
            };
        }
        case types.ERROR_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                errorModalProps: { isVisible: payload.isVisible, error: payload.error || {} },
            };
        }
        case types.ACTION_BLOCK_CHANGED: {
            return {
                ...state,
                actionBlock: {
                    ...state.actionBlock,
                    actions: payload,
                },
            };
        }
        case types.ACTION_BLOCK_FETCHING: {
            return {
                ...state,
                actionBlock: {
                    ...state.actionBlock,
                    isFetching: payload,
                },
            };
        }
        case types.CONFIRM_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                confirmModalProps: {
                    ...state.confirmModalProps,
                    ...payload,
                },
            };
        }
        case types.CURRENT_PAGE_TITLE_CHANGED: {
            return {
                ...state,
                currentPage: payload,
            };
        }
        case types.TRANSLATION_MODE_CHANGED: {
            return {
                ...state,
                translationMode: payload,
            };
        }
        case types.DOWNLOAD_FILE_LIST_CHANGED: {
            return {
                ...state,
                downloadFileList: payload,
            };
        }
        case types.CANCEL_DOWNLOAD_FILE: {
            const fileId = action.payload;
            return {
                ...state,
                downloadFileList: state.downloadFileList.filter(f => f.id !== fileId),
            };
        }
        default:
            return state;
    }
};

export default global;
